import * as React from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" {...props}>
    <circle cx={12} cy={12.482} r={12} fill="#92B0BA" />
    <circle cx={12.001} cy={12.482} r={5.455} fill="#fff" />
  </svg>
)
export default SvgComponent
